function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from "react";
var DEFAULT_PAGE_PARAM = "page";
var DEFAULT_CURRENT_PAGE = 1;
export var useCurrentPage = function useCurrentPage(_ref) {
  var itemPerPage = _ref.itemPerPage,
    _ref$currentPageNumbe = _ref.currentPageNumber,
    currentPageNumber = _ref$currentPageNumbe === void 0 ? DEFAULT_CURRENT_PAGE : _ref$currentPageNumbe,
    _ref$initSearchParams = _ref.initSearchParams,
    initSearchParams = _ref$initSearchParams === void 0 ? "" : _ref$initSearchParams;
  var searchParams = new URLSearchParams(initSearchParams);
  var pageNumber = searchParams.has(DEFAULT_PAGE_PARAM) ? Number.parseInt(searchParams.get(DEFAULT_PAGE_PARAM), 10) : currentPageNumber;
  var _useState = useState(pageNumber),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var resetCurrentPage = function resetCurrentPage() {
    if (typeof window !== "undefined") {
      var url = new URL(window.location);
      url.searchParams.set(DEFAULT_PAGE_PARAM, String(DEFAULT_CURRENT_PAGE));
      window.history.pushState({}, "", url);
      setCurrentPage(DEFAULT_CURRENT_PAGE);
    }
  };
  useEffect(function () {
    setCurrentPage(pageNumber);
  }, [pageNumber]);

  /*
   * startIndex & endIndex
   * are used to navigate into a data array with the slice method
   * This can be useful if you are paging on an array of static data without a paginate API.
   *
   * e.g :
   * pageNumber = 4
   * itemPerPage = 10
   *
   * startIndex = (pageNumber (4) - 1) * itemPerPage (10) // equal to 30
   * endIndex  = startIndex (30) + itemPerPage (10) // equal to 40
   *
   * We can use a slice method to return a portion of an array
   * into a new array object selected from startIndex to endIndex
   * where startIndex and endIndex represent the index of items in that array.
   */
  var startIndex = (pageNumber - 1) * itemPerPage;
  var endIndex = startIndex + itemPerPage;
  return {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    resetCurrentPage: resetCurrentPage,
    startIndex: startIndex,
    endIndex: endIndex
  };
};